import React from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { ReduxEntitySelect } from 'components/FormElements'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// graphql
import { COMPANIES_SELECT_QUERY } from 'graphql/company/queries'
// utils
import { companyProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const Wrapper = styled((props) => <Grid {...props} />)`
  && {
    margin: 0;
    padding: 16px;
    width: inherit;

    & > :last-child {
      margin: 8px 8px 0 auto;
      width: fit-content;
    }
  }
`

interface IIncomingProps {
  clearFilter: () => void
  handleSelectChange: () => void
}

const Filter: React.FC<IIncomingProps> = ({ clearFilter, handleSelectChange }) => {
  return (
    <Wrapper container spacing={2} direction={'column'} wrap={'nowrap'}>
      <Grid>
        <ReduxEntitySelect
          label={'Account'}
          name={'companyId'}
          onSelectChange={handleSelectChange}
          query={COMPANIES_SELECT_QUERY}
          {...companyProps}
        />
      </Grid>
      <Button type={'button'} layout={BUTTON_LAYOUTS.GRAY} onClick={clearFilter}>
        Clear
      </Button>
    </Wrapper>
  )
}

export default Filter
